module.exports = __webpack_public_path__ + "static/media/event-services-img12.568a71d9.jpg";